import { render, staticRenderFns } from "./FormSecundario.vue?vue&type=template&id=3dcc47d8&"
import script from "./FormSecundario.vue?vue&type=script&lang=js&"
export * from "./FormSecundario.vue?vue&type=script&lang=js&"
import style0 from "./FormSecundario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports